import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { Performances } from "@/components/site/Performances";
import { HotelCasino } from "@/components/site/HotelCasino";
import { Events } from "@/components/site/Events";
import { Reservation } from "@/components/site/Reservation";
import { Careers } from "@/components/site/Careers";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App grain min-h-screen bg-obsidian text-white font-body antialiased">
        <Navbar />
        <main>
          <Hero />
          <BrandMarquee />
          <About />
          <Gallery />
          <Performances />
          <HotelCasino />
          <Events />
          <Reservation />
          <Careers />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFab />
        <Toaster position="top-center" theme="dark" richColors offset="96px" />
      </div>
    </LanguageProvider>
  );
}

export default App;
